import type { PaletteOptions } from '@mui/material/styles';
import { brand, colors } from './tokens';

export const palette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: brand.blue600,
    light: brand.blue400,
    dark: brand.blue700,
    contrastText: brand.white,
    50: brand.blue50,
    100: brand.blue100,
    200: brand.blue200,
    300: brand.blue300,
    400: brand.blue400,
    500: brand.blue500,
    600: brand.blue600,
    700: brand.blue700,
    800: brand.blue800,
    900: brand.blue900,
  },
  secondary: {
    main: brand.gold,
    light: brand.goldLight,
    dark: brand.goldDark,
    contrastText: brand.navy,
    50: brand.goldLight,
    100: brand.goldLight,
    200: brand.goldLight,
    300: brand.gold,
    400: brand.gold,
    500: brand.gold,
    600: brand.goldDark,
    700: brand.goldDark,
  },
  success: { 
    main: brand.success,
    light: brand.successLight,
    contrastText: brand.white,
  },
  warning: { 
    main: brand.warning,
    light: brand.warningLight,
    contrastText: brand.navy,
  },
  error: { 
    main: brand.error,
    light: brand.errorLight,
    contrastText: brand.white,
  },
  info: { 
    main: brand.info,
    light: brand.infoLight,
    contrastText: brand.white,
  },
  grey: colors.neutral,
  background: {
    default: brand.background,
    paper: brand.white,
  },
  text: {
    primary: brand.textPrimary,
    secondary: brand.textSecondary,
    disabled: brand.textMuted,
  },
  divider: brand.border,
  textColors: colors.text,
  backgrounds: colors.background,
  common: {
    black: brand.navy,
    white: brand.white,
  },
};
